"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ApiRoutes = {
    Auth: {
        GetToken: function () { return "/auth/token"; },
    },
    Documents: {
        Get: function (documentTypeId) { return "/documents?DocumentTypeId=" + documentTypeId; },
        Create: function () { return "/documents/create"; },
        Update: function () { return "/documents/update"; }
    },
    Posts: {
        Get: function (pageNumber, pageSize) { return "/posts?PageNumber=" + pageNumber + "&PageSize=" + pageSize; },
        Create: function () { return "/posts/create"; },
        Update: function () { return "/posts/update"; }
    },
    Sponsors: {
        Get: function () { return "/sponsors"; },
        Update: function () { return "/sponsors/update"; },
        Create: function () { return "/sponsors/create"; },
    },
    Suggestions: {
        Get: function (pageNumber, pageSize, showRead) { return "/suggestions?PageNumber=" + pageNumber + "&PageSize=" + pageSize + "&ShowRead=" + showRead; },
        Create: function () { return "/suggestions/create"; },
        Update: function () { return "/suggestions/update"; }
    },
    Events: {
        Get: function (year, month) { return "/events?Year=" + year + "&Month=" + month; },
        Update: function () { return "/events/update"; },
        UpdateEventsList: function () { return "/events/updateEventsList"; },
        Create: function () { return "/events/create"; },
    },
    Users: {
        Get: function (showInactive) { return "/users?showInactive=" + showInactive; },
        Update: function () { return "/users/update"; },
        Create: function () { return "/users/create"; },
        ForgotPassword: function () { return "/users/forgotPassword"; },
        ResetPassword: function () { return "/users/resetPassword"; },
    },
};
exports.default = ApiRoutes;
//# sourceMappingURL=ApiRoutes.js.map